const michelleMarocco = {
  _id: "michelle-marocco",
  firstName: "Michelle",
  lastName: "Marocco",
  bioText:
    "<p>Even if you have never met Michelle before, you may have seen her work already on celebrities like Russell Brand, Nicole Scherzinger, Elaine Irwin, or Frankie Ballard.  Michelle Marocco has earned international acclaim as a jewelry artist, having been personally invited to Saudi Arabia by the royal family to exhibit the Marocco collection at an annual women-only charity event.  Her one-of-a-kind works of wearable art are in high demand, inspired by meditation and her yoga practice. Although yoga is a strong influence in her work, it is her family which is the deepest root of all of her inspiration and which she puts forst.  Her two sons, Gavin and Justin, always motivate her to design and create.</p><p>Michelle started making jewelry eight years ago. Five years ago, she forged the guiding concept of &ldquo;The Audacity Of Diamonds On Leather&rdquo;. To this day, each of her handcrafted pieces adhere to these conceptual roots, crafted to be a piece of wearable artwork infused with the contemplative energy of the creator.</p><p>Michelle&rsquo;s passion in life is to be in the moment of the creative process, driven to capture and harness that compelling urgency to create works of art that channel positive energy and help rejuvenate the soul.  The Marocco line includes numerous, unique collections born out of her multidimensional imagination: as she describes it, &ldquo;I like to style both the body and spirit with my jewelry.&rdquo;/p><p> Michelle&rsquo;s talents also extend to paintings: she is an accomplished abstract-expressionist and figurative painter with a 15-year career on canvas.   The dialogue braided into her paintings narrates, with layers of textures and symbols, the complex history and influences that shape us.  This theme comes from her reverence for the life principle of Niyama, or purification through self-discipline, a part of the eightfold path of yoga.</p>",
  tagline: "The Audacity Of Diamonds On Leather",
  bannerSrc: "/img/artists/michelle-marocco/michelle-marocco-banner.jpg",
  portraitSrc: "/img/artists/michelle-marocco/michelle-marocco-portrait.jpg",
  galleryItems: [
    {
      imgname: "BusyGirl Pendants",
      src: "michelle-marocco-pendants.jpg",
      alt:
        "A collection of several beautiful pendants by Michelle Marocco, part of her BusyGirl and Niyama collections."
    },
    {
      imgname: "Diamond Shaker Pendant",
      src: "michelle-marocco-diamond-shaker-pendant.jpg",
      alt:
        "A unique pendant by Michelle Marocco that boasts 1.8 karats of brilliant diamonds. Part of her BusyGirl collection."
    },
    {
      imgname: "Michelle Marocco BusyGirl Bracelets",
      src: "michelle-marocco-bracelets.jpg",
      alt:
        "A collection of bracelets by Michelle Marocco, featuring sapphire and snakeskin for a layered look and paired with silver and diamond bands."
    },
    {
      imgname: "Curled Feather Diamond Pendant",
      src: "michelle-marocco-curled-diamond-feather-pendant.jpg",
      alt:
        "A feather diamond pendant.  Part of Michelle Marocco's BusyGirl collection."
    },
    {
      imgname: "Arrowhead Pendant",
      src:
        "michelle-marocco-labradorite-and-feather-choker-with-arrowhead-pendant.jpg",
      alt:
        "Another piece from Michelle Marocco's BusyGirl collection, this one featuring an arrowhead pendant and a labradorite-and-silver  choker."
    },
    {
      imgname: "Friend Of Buddha Necklace",
      src: "michelle-marocco-friend-of-buddha-necklace.jpg",
      alt:
        "Friend Of Buddha necklace by Michelle Marocco. A beaded necklace with a buddha pendant, part of the Niyama by Marocco collection."
    },

    {
      imgname: "Stitched Leather Bead Bracelet",
      src: "michelle-marocco-stitched-leather-bead-bracelet.jpg",
      alt:
        "A stitched leather bead bracelet by Michelle Marocco. The bracelet is made with a magnetic clasp for easy wearing and removal."
    },
    {
      imgname: "Labradodrite Bezel Choker Necklace",
      src: "michelle-marocco-labradorite-bezel-choker.jpg",
      alt:
        "Minimalist design with maximum style by Michelle Marocco. You will get lost in the mysterious depths of this faceted labradorite necklace."
    },
    {
      imgame: "Diamond Love Necklace",
      src: "michelle-marocco-diamond-love-and-coin-necklace.jpg",
      alt:
        "A hand-crafted necklace by Michelle Marocco. Wear this necklace alone for a simple statement, or compliment it with other pieces."
    },
    {
      imgname: "Diamond Snake Pendant",
      src: "michelle-marocco-snake-pendant.jpg",
      alt:
        "A pav&eacute; diamond snake pendant by Michelle Marocco as part of her BusyGirl collection, paired with a bronze dome with a rich patina."
    },
    {
      imgname: "Men's textured tile braelet",
      src: "michelle-marocco-bronze-textured-tile-bracelet.jpg",
      alt:
        "Men's bracelet by Michelle Marocco. Part of her ManGear collection.  This bracelet features a kiln-fired textured tile with a strand of crocheted leather."
    },
    {
      imgname: "Silver Textured Tile Bracelet",
      src:
        "michelle-marocco-fire-agate-and-pyrite-beaded-bracelet-with-silver-tile.jpg",
      alt:
        "Men's bracelet by Michelle Marocco as part of her ManGear collection. A textured sterling silver tile pairs with strips of black leather for a smart and sophisticated look."
    }
  ]
};

const kaneScheidegger = {
  _id: "kane-scheidegger",
  firstName: "Kane",
  lastName: "Scheidegger",
  bioText:
    "<p>Kane Scheidegger is a landscape and ski photographer based in Ridgway and Telluride who combs aspen groves and climbs mountains to capture that perfect, exhilirating moment where Mother Nature shows off her splendor: long-lost waterfalls, the magical hues of Autumnal skies, and the majestic mountains are just a sample of the gems he hunts for in Southwest Colorado and the rest of the world.</p><p>Kane&rsquo;s images stretch across eight foot tall canvases, many of them sweeping panoramas, to immerse the viewer into the moment.</p><p>Winter is one of Kane&rsquo;s favorite seasons because of the variety it brings, from tranquil days in the snow-capped mountains to daring descents down dizzying ski-runs. During the snowy season he photographs everything from extreme skiing to tranquil moments of clearing storms and quiet ski approaches through the wind-carved, sastrugi snow. </p><p>Kane was born and raised in Ridgway, Colorado and earned a Bachelors of Science in graphic arts.  After setting up a graphics company in Southwest Colorado, he pursued his passion of photography.  He is self taught through perseverance and many outings in search of perfect light and composition. Many of his photographs are taken using a  technical camera. He loves the methodical process and tactile workflow of this technique and the stunning quality, crispness, and contrast that this type of camera provides.  He currently uses Phase One's A-Series 100 megapixel camera and for his ski photography, he enjoys the portability and durability of Canon's 5dsr 50 megapixel camera.</p>",
  tagline: "Larger Than Life Photography",
  bannerSrc: "/img/artists/kane-scheidegger/kane-scheidegger-banner.jpg",
  portraitSrc: "/img/artists/kane-scheidegger/kane-scheidegger-portrait.jpg",
  galleryItems: [
    {
      imgname: "Aspen Grove",
      src: "kane-scheidegger-aspen-forest.jpg",
      alt: "An aspen grove by photographer Kane Scheidegger."
    },
    {
      imgname: "placeholder",
      src: "kane-scheidegger-avalanche.jpg",
      alt: "Alt placeholder"
    },
    {
      imgname: "Sneffels Mountain Range",
      src: "kane-scheidegger-black-and-white-mountains.jpg",
      alt: "Sneffels mountain range by photographer Kane Scheidegger."
    },
    {
      imgname: "Blue Spruce",
      src: "kane-scheidegger-blue-spruce.jpg",
      alt: "Blue Spruce in winter by photographer Kane Scheidegger."
    },
    {
      imgname: "placeholder",
      src: "kane-scheidegger-colorado-mountain-valley.jpg",
      alt: "Alt placeholder"
    },
    {
      imgname: "placeholder",
      src: "kane-scheidegger-mountain-lake.jpg",
      alt: "Alt placeholder"
    },
    {
      imgname: "placeholder",
      src: "kane-scheidegger-mountain-range.jpg",
      alt: "Alt placeholder"
    },
    {
      imgname: "placeholder",
      src: "kane-scheidegger-mount-wilson.jpg",
      alt: "Alt placeholder"
    },
    {
      imgname: "placeholder",
      src: "kane-scheidegger-san-juan-river.jpg",
      alt: "Alt placeholder"
    },
    {
      imgname: "placeholder",
      src: "kane-scheidegger-ski-slopes.jpg",
      alt: "Alt placeholder"
    },
    {
      imgname: "placeholder",
      src: "kane-scheidegger-sunset-lake.jpg",
      alt: "Alt placeholder"
    },
    {
      imgname: "placeholder",
      src: "kane-scheidegger-telluride.jpg",
      alt: "Alt placeholder"
    }
  ]
};

const mattDowner = {
  _id: "matt-downer",
  firstName: "Matt",
  lastName: "Downer",
  bioText:
    "<p>Matt Downer's work begs to be touched with its bold allure, hand-crafted contours, and nuanced detail that belies a lifetime of experience and craftsmanship. Ever since he was a kid making sketchy skateboard ramps and catapults, Matt has been fascinated with creating things that work.</p><p>Raised in Manhattan Beach, California, Matt graduated from CSUChico with a Bachelors of Art in Philosophy and Religious Studies.Soon after, he loaded his volkswagen to wander the west and landedin Telluride, Colorado, where he found and honed his skills atSteeprock Joinery. Freed from the cramped cells that Californiaapartments used to quarter him in, he finally was able to stretchout his wood lathe in the vibrant and verdant Rockies. Hiscontemporaries, like Christoph Neander, inspired him withmuseum-quality work to nuture an appreciation of his hand-madepieces by valuing the finest of details and every nuance of closeinspection.</p><p>One of the great pleasures of working with wood is its the richtactility. &ldquo;My hope is that every one of my clients willcaress each piece I&rsquo;ve made for them on a regularbasis,&rdquo; Matt says. &ldquo;By feeling the curves and sensingthe flow of the grain, the piece stands apart from a world full ofobjects spat out by some machine on the other side of the planet.Painstakingly crafted by attentive eyes and practiced hands, everysurface of every piece I make is worked so as to bring life backto the wood that once grew as a beautiful tree.&rdquo;</p><p>Curved pieces with exposed joinery, pegged through-tenons, andartful dovetails compose a theme throughout Matt&rsquo;s designs,rendering each work unique not only to itself but to none otherthan Downer himself. Cherry, Maple and Black Walnut are his mostpopular materials, but any wood with the potential to enhance acustom-made piece may find itself in his hands, as well as metal,glass, stone and inlays of copper and silver.</p>",
  tagline: "Custom Woodwork And Fine Furniture",
  bannerSrc: "/img/artists/matt-downer/matt-downer-banner.jpg",
  portraitSrc: "/img/artists/matt-downer/matt-downer-portrait.jpg",
  galleryItems: [
    {
      imgname: "bed",
      src: "matt-downer-bed.jpg",
      alt: "A bed"
    },
    {
      imgname: "bluemobile",
      src: "matt-downer-blue-mobile.jpg",
      alt: "A blue mobile"
    },
    {
      imgname: "chandelier",
      src: "matt-downer-chandelier.jpg",
      alt: "A chandelier"
    },
    {
      imgname: "sculpted-chairs",
      src: "matt-downer-cherry-sculpted-dining-chairs.jpg",
      alt: "Cherry-wood sculpted dining chairs"
    },
    {
      imgname: "drawers",
      src: "matt-downer-drawers.jpg",
      alt: "Custom set of drawers"
    },
    {
      imgname: "shelves",
      src: "matt-downer-shelving.jpg",
      alt: "Shelves"
    },
    {
      imgname: "lighting",
      src: "matt-downer-lighting.jpg",
      alt: "A chandelier with a rock accent"
    },
    {
      imgname: "table",
      src: "matt-downer-table.jpg",
      alt: "A table"
    },
    {
      imgname: "table-detail",
      src: "matt-downer-table-detail.jpg",
      alt: "A detail of metal accent on a wooden table"
    }
  ]
};

const kiraFercho = {
  _id: "kira-fercho",
  firstName: "Kira",
  lastName: "Fercho",
  tagline: "Art Customized For The Home And The Soul",
  bioText:
    "<p>Kira's generous application of paint in soulful, texture-rich hues leap out from their canvases to tug on the personal passions of their individual owners:  each of her works are custom-tailored for their space, context and the viewer-to-be. Every piece is crafted after she cutivates a one-on-one relationship with her client, be they a homeowner looking for the perfect statement piece, an architect or interior designer looking to crown their latest contract, or a corporate entrepreneur brightening up her boardroom.</p><p> Her artistic training in Russian Impressionism fills her compositions with a complex study of light and color and offers an almost lyrical feel to her representations of land and life. Her background in Western Tonalism renders her subjects with an evocative, spiritual effect wrought from weaving complex mid-range tones. Her life experiences inspire her subject-matter:  as a native of eastern Montana, Kira grew up with a reverence for the High Plains, its culture, its land and its people.</p><p>&ldquo;Everyone loves the mountains of the West, but not everyone gets to really experience and appreciate the prairies and badlands,&rdquo; she says. &ldquo;From my perspective, as someone who grew up in this environment, the High Plains have equal grandeur and dramatic beauty and maybe even more gradation in color&mdash;so much material to work with.&rdquo; <p>Kira learned how to find her voice from Montana western artist Loren Entz, and a pivotal part of that guidance was embracing the unexpected places that painting can take her brush. &ldquo;Part of the process is stumbling through things,&rdquo; she says.  &ldquo;When I was having trouble making a decision... and eventually we all have to make decisions... he said, &lsquo;Just do it. Move forward even when it gets difficult. At times it is better to make huge mistakes than have small victories.&rdquo;</p>",
  bannerSrc: "/img/artists/kira-fercho/kira-fercho-banner.jpg",
  portraitSrc: "/img/artists/kira-fercho/kira-fercho-portrait.jpg",
  galleryItems: [
    {
      imgname: "Wisdom",
      src: "kira-fercho-wisdom.jpg",
      alt: "Wisdom by painter Kira Fercho"
    },
    {
      imgname: "Winter Light",
      src: "kira-fercho-winter-light.jpg",
      alt: "Winter Light by painter Kira Fercho"
    },
    {
      imgname: "Soulful Simplicity",
      src: "kira-fercho-soulful-simplicity.jpg",
      alt: "Soulful Simplicity by painter Kira Fercho"
    },
    {
      imgname: "Soul",
      src: "kira-fercho-soul.jpg",
      alt: "Soul by painter Kira Fercho"
    },
    {
      imgname: "Seasonal Changes",
      src: "kira-fercho-seasonal-changes.jpg",
      alt: "Seasonal Changes by painter Kira Fercho"
    },
    {
      imgname: "Riders",
      src: "kira-fercho-riders.jpg",
      alt: "Riders by painter Kira Fercho"
    },
    {
      imgname: "Rain Dancers",
      src: "kira-fercho-rain-dancers.jpg",
      alt: "Rain Dancers by painter Kira Fercho"
    },
    {
      imgname: "Protectors",
      src: "kira-fercho-protectors.jpg",
      alt: "Protectors by painter Kira Fercho"
    },
    {
      imgname: "Huckleberry",
      src: "kira-fercho-huckleberry.jpg",
      alt: "Huckleberry by painter Kira Fercho"
    },
    {
      imgname: "Fall Is My Favorite Color",
      src: "kira-fercho-fall-is-my-favorite-color.jpg",
      alt: "Fall Is My Favorite Color by painter Kira Fercho"
    },
    {
      imgname: "Clint",
      src: "kira-fercho-clint.jpg",
      alt: "Clint by painter Kira Fercho"
    },
    {
      imgname: "Autumn Harmony",
      src: "kira-fercho-autumn-harmony.jpg",
      alt: "Autumn Harmony by painter Kira Fercho"
    }
  ]
};

const artistData = {
  [mattDowner._id]: mattDowner,
  [michelleMarocco._id]: michelleMarocco,
  [kaneScheidegger._id]: kaneScheidegger,
  [kiraFercho._id]: kiraFercho
};

export default artistData;



// WEBPACK FOOTER //
// ./src/data/artist-data.js